import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';

import { EllipsisTooltipDirective } from '@shared/common';

@Component({
  selector: 'la-metrics-card',
  templateUrl: './metrics-card.component.html',
  styleUrl: './metrics-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCardModule, MatTooltipModule, EllipsisTooltipDirective],
})
export class MetricsCardComponent {
  @Input() title!: string;
  @Input() description!: string;
}
